import { render, staticRenderFns } from "./triangle_polygon.vue?vue&type=template&id=74291a25&"
import script from "./triangle_polygon.vue?vue&type=script&lang=js&"
export * from "./triangle_polygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports